// Anchor block naming: Project Code_ANC[-suffix]_Type Code
// e.g. "MTS_ANC_001", "REA_ANC-A_012". Anchors are not panels.
const ANCHOR_TOKEN = /(?:^|[^a-z0-9])anc(?:-[a-z0-9]+)?(?:[^a-z0-9]|$)/i;

export function isAnchorBlock(name) {
  return !!name && ANCHOR_TOKEN.test(name);
}

// Panel blocks carry a P<digits> code or a P- prefix: "MTS_P1", "T3_P01", "P-RAY…".
const PANEL_TOKEN = /(?:^|[^a-z0-9])p(?:\d|-)/i;

export function isPanelBlock(name) {
  return !!name && PANEL_TOKEN.test(name);
}

/** "REA_ANC-A_012" -> { projectCode: "REA", anchorCategory: "ANC-A", typeCode: "012" } */
export function parseAnchorBlock(name) {
  const parts = (name || "").split("_");
  return {
    projectCode: parts[0] || "",
    anchorCategory: parts.length > 2 ? parts.slice(1, -1).join("_") : "",
    typeCode: parts.length > 1 ? parts[parts.length - 1] : "", // leading zeros kept
  };
}
